(() => {
  const initLoadMore = (button) => {
    if (button.dataset.loadMoreBound === 'true') return;
    button.dataset.loadMoreBound = 'true';

    button.addEventListener('click', () => {
      const batch = Number(button.dataset.batch) || 4;
      const grid = document.getElementById(button.dataset.gridId);
      const footer = document.getElementById(button.dataset.footerId);
      if (!grid) return;

      const hiddenItems = grid.querySelectorAll('.is-hidden');
      hiddenItems.forEach((item, index) => {
        if (index < batch) item.classList.remove('is-hidden');
      });

      if (grid.querySelectorAll('.is-hidden').length === 0 && footer) {
        footer.remove();
      }
    });
  };

  const bindAll = () => {
    document.querySelectorAll('[data-collection-load-more]').forEach(initLoadMore);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', bindAll);
})();
